var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center lead",staticStyle:{"padding-top":"15%"}},[_vm._v("\n  Ooops, it seems you don't have access to any BOLT Jobs."),_c('br'),_vm._v("\n  Please contact BOLT administrators for any questions.\n")])
}]

export { render, staticRenderFns }